import { current } from "@reduxjs/toolkit";
import api from "./api";
import UserService from "./user.service";
import { useSelector } from "react-redux";
import { isAccountant, isAdmin } from "src/Common/function";

const getAll = (keyword, config = {}) => {
  return api.get("/api/customer/get_all", { params: { keyword }, ...config });
};

// Lightweight picker for the WO create modal and WO filter. Hits an ungated
// endpoint so selecting a customer doesn't require customer:read; returns
// active customers with id/companyName only.
const getForAssign = (keyword) => {
  return api.get("/api/customer/get_for_assign", { params: { keyword } });
};

const saveCustomer = (customer) => {
  return api.post("/api/customer/add_customer", customer);
};

const archiveCustomer = (id) => {
  return api.post("/api/customer/archive_customer", { customerId: id });
};

const restoreCustomer = (id) => {
  return api.post("/api/customer/restore_customer", { customerId: id });
};

const updateCustomer = (customer) => {
  return api.post("/api/customer/update_customer", { ...customer });
};

const getOne = (customerId) => {
  return api.get("/api/customer/get_one", { params: { customerId } });
};

const getArchivedByAccount = (accountId) => {
  return api.get("/api/customer/get_archived", { params: { accountId } });
};

const CustomerService = {
  getOne,
  getAll,
  getForAssign,
  getArchivedByAccount,
  saveCustomer,
  archiveCustomer,
  restoreCustomer,
  updateCustomer,
};

export default CustomerService;
